import { IRoute } from "../../../common/helpers/routesMapper";

import { connect } from "react-redux";
import withRouter from "../../utils/withRouter";
import injectIntl from "../../../common/helpers/injectIntl";

import routing from "../../routing";
import { seo } from "../../../common/helpers/seo";
import getPlanSeo from "../../../common/helpers/getPlanSeo";

import resetPlan from "../../store/plan/actions/resetPlan";
import getPlan from "../../store/plan/actions/getPlan";
import { getModerationProcess } from "../../store/testModeration/actions";
import { IStateTree } from "../../store/interfaces";

import lazyComponent from "./lazy";
import { Store } from "redux";
import { IPlan } from "../../../common/types";
import { IUser } from "../../store/user/models";
import { IPlanState } from "../../store/plan/models";
import { post } from "../../actions/general";

const mapStateToProps = ({ plan, user, testModeration }: IStateTree) => ({
    plan: plan as IPlan,
    user: user as IUser,
    testModeration,
});

const mapDispatchToProps = { getPlan, resetPlan, getModerationProcess, post };

export default {
    component: withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(lazyComponent))),
    loadData: ({ dispatch }: Store<IStateTree, any>, path: string) => dispatch(getPlan(path)),
    renderSeo: ({ getState }: Store<IStateTree>, allMessage: {[key: string]: string}, lang: string, path: string, context: { redirect?: string, notFound?: boolean }) => {
        const plan = getState().plan as IPlanState;
        if ((plan as IPlan).redirect) {
            context.redirect = `/${routing.publicPlan}/${(plan as IPlan).publicId}`;
            return;
        }
        if (!plan || (plan as {
            loading?: boolean,
            error?: boolean,
            notFound?: boolean,
        }).error) {
            context.notFound = true;
            return seo({
                title: allMessage.notFound,
                type: "article",
                noindex: true,
                nofollow: true,
                allMessage,
                lang,
            });
        }
        const publicView =
            path.slice(1, routing.publicPlan.length + 1) === routing.publicPlan ||
            path.slice(1, routing.testModeration.length + 1) === routing.testModeration;
        const planSeo = getPlanSeo(plan as IPlan, { locale: lang }, publicView, path);
        return seo({
            ...planSeo,
            allMessage,
            lang,
        });
    },
} satisfies IRoute;
